module.exports = __webpack_public_path__ + "img/Pika-logo-bel.06f42d8b.svg";